import axios from "@/services/axios";
import { BehaviorSubject } from "rxjs";
import { ContactFolder } from "@/models/contact-folder";

export interface ContactFolderState {
  data: ContactFolder[];
  isDataLoaded: boolean;
  isLoading: boolean;
}

const initialState: ContactFolderState = {
  data: [],
  isDataLoaded: false,
  isLoading: false,
};

export { initialState as contactFolderInitialState };

class ContactFolderService {
  private readonly contactFolders = new BehaviorSubject<ContactFolderState>(
    initialState,
  );

  private get contactFoldersData() {
    return this.contactFolders.getValue();
  }

  private set contactFoldersData(data) {
    this.contactFolders.next(data);
  }

  readonly contactFolders$ = this.contactFolders.asObservable();

  defaultContactFolder?: ContactFolder;

  fetchSettingsContactFolders(): Promise<any> {
    return axios.get(`/api/contacts/contact-folders`);
  }

  updateCustomFieldMapping(
    contactFolderId: string,
    customFieldsMapping: object,
  ): Promise<boolean> {
    this.contactFoldersData = { ...this.contactFoldersData, isLoading: true };
    return new Promise((resolve) => {
      axios
        .put(`/api/contacts/${contactFolderId}`, customFieldsMapping)
        .then((response) => {
          const index = this.contactFoldersData.data.findIndex(
            (i) => i.contactFolderId === contactFolderId,
          );
          if (response.status === 200 && index > -1) {
            const data = this.contactFoldersData.data;
            data[index] = {
              ...this.contactFoldersData.data[index],
              customFieldsMapping,
            };
            this.contactFoldersData = {
              ...this.contactFoldersData,
              data,
              isLoading: false,
            };
            resolve(true);
          } else {
            this.contactFoldersData = {
              ...this.contactFoldersData,
              isLoading: false,
            };
            resolve(false);
          }
        })
        .catch(() => {
          this.contactFoldersData = {
            ...this.contactFoldersData,
            isLoading: false,
          };
          resolve(false);
        });
    });
  }

  getAccountContactFolders(
    pageIndex: number,
    pageSize: number,
    sortField?: string,
    sortOrder?: string,
    searchText?: string,
  ): Promise<any[]> {
    const dir =
      sortOrder === "descend" ? sortField + ",DESC" : sortField + ",ASC";
    const sort = sortField && sortOrder != "none" ? dir : "";
    let pageable: any = {
      page: pageIndex,
      size: pageSize,
      sort,
    };
    if (searchText) {
      pageable["filter"] = searchText;
    }
    return axios.get(`/api/contacts/organisation/contact-folders`, {
      params: pageable,
    });
  }

  assignUser(userData: any, contactFolderId: string): Promise<any> {
    return axios.put(
      `/api/contacts/organisation/contact-folder/${contactFolderId}/access`,
      userData,
    );
  }

  updateContactFolderName(
    alias: string,
    contactFolderId: string,
  ): Promise<any> {
    if (!alias || !contactFolderId) {
      return Promise.resolve();
    }
    return axios.put(
      `/api/contacts/contact-folder/${contactFolderId}?alias=${alias}`,
    );
  }
}
export const contactFolderService = new ContactFolderService();
